import { Box } from "@mui/material";
import { styled } from "@mui/system";

const FlexBetweeen = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export default FlexBetweeen;
